import { Box } from "@mui/material";
import { useState } from "react";
import useAPI from "../../../../../api/hooks/useAPI";
import { useCheckUserPermission } from "../../../../../api/hooks/useCheckUserPermission";
import useColors from "../../../../../api/hooks/useColors";
import OutlinedButton from "../../../../../components/buttons/OutlinedButton";
import CustomToolTipWithPermission from "../../../../../components/CustomToolTipWithPermission";
import { PLATFORM_USER_ACTIONS } from "../../../../../utils/constants";
import { icons } from "../../icons/iconExport";
import AssetsDropdownChecklist from "./AssetsDropdownChecklist";

export default function MarkAsCriticalButton({ checkedEntityIDs, assets }) {
  const colors = useColors();
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const { trackEvent } = useAPI();

  const { permitted: hasPermission } = useCheckUserPermission(
    PLATFORM_USER_ACTIONS.MODIFY_ASSET
  );

  const handleClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
    trackEvent(
      `User clicked the "Add to Critical Asset" button for ${checkedEntityIDs.length} checked entities`
    );
  };

  return (
    <CustomToolTipWithPermission title={""} permission={hasPermission}>
      <Box>
        <OutlinedButton
          disabled={checkedEntityIDs.length === 0 || !hasPermission}
          onClick={(event) => {
            handleClick(event);
          }}
          color="inherit"
          size="small"
          icon={icons.DefaultAssetIcon}
          iconSize={16}
        >
          Critical Assets
        </OutlinedButton>
        {menuAnchorEl && (
          <AssetsDropdownChecklist
            key={assets}
            menuAnchorEl={menuAnchorEl}
            setMenuAnchorEl={setMenuAnchorEl}
            checkedEntityIDs={checkedEntityIDs}
            assets={assets}
          />
        )}
      </Box>
    </CustomToolTipWithPermission>
  );
}
